import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, EASE, CHAKRAS } from "./shared";

export default function Film() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [40, -40]);

  return (
    <section
      ref={ref}
      className="relative py-20 lg:py-32 bg-[#1B1915] overflow-hidden"
      data-testid="film-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <Reveal>
            <p className="text-xs tracking-[0.28em] uppercase text-[#C6A15B] mb-6" data-testid="film-eyebrow">
              ELYNCOR ELEMENTS — In Motion
            </p>
            <h2
              className="font-serif-display font-light tracking-tight leading-[1.12] text-[#FDFBF7] text-3xl sm:text-4xl lg:text-5xl"
              data-testid="film-title"
            >
              Every Stone,
              <br />
              <span className="italic text-[#C6A15B]">Catching the Light.</span>
            </h2>
            <p className="mt-8 text-base sm:text-lg text-[#FDFBF7]/65 leading-relaxed max-w-md" data-testid="film-text">
              A slow cinematic orbit of the 7 Chakra Gemstone Tree — watch each colour
              group turn through warm light, from white at the crown to red at the root.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-10 flex flex-wrap gap-3" data-testid="film-chakra-dots">
              {CHAKRAS.map((c) => (
                <span
                  key={c.key}
                  className={`w-2.5 h-2.5 rounded-full ${c.light ? "border border-[#FDFBF7]/40" : ""}`}
                  style={{ backgroundColor: c.hex }}
                  title={c.name}
                />
              ))}
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7 order-1 lg:order-2 flex justify-center">
          <motion.div
            style={{ y }}
            initial={{ opacity: 0, scale: 0.96 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1.2, ease: EASE }}
            className="relative w-full max-w-[340px] sm:max-w-[420px]"
            data-testid="film-video-frame"
          >
            <div className="absolute -inset-3 border border-[#FDFBF7]/15 rounded-sm" />
            <video
              poster="/assets/tree-studio.jpg"
              autoPlay
              muted
              loop
              playsInline
              className="relative w-full rounded-sm shadow-[0_60px_80px_rgba(0,0,0,0.45)]"
              data-testid="film-video"
            >
              <source src="/assets/tree-film.webm" type="video/webm" />
              <source src="/assets/tree-film.mp4" type="video/mp4" />
            </video>
            <p className="font-hand text-xl text-[#C6A15B]/90 mt-6 text-center" data-testid="film-caption">
              a quiet orbit, in warm light
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
